import { render, staticRenderFns } from "./qpgtt.vue?vue&type=template&id=2b0cbd3d&scoped=true"
import script from "./qpgtt.vue?vue&type=script&lang=js"
export * from "./qpgtt.vue?vue&type=script&lang=js"
import style0 from "./qpgtt.vue?vue&type=style&index=0&id=2b0cbd3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0cbd3d",
  null
  
)

export default component.exports